import React from 'react';

interface MandatoryLabelI {
  marginLeft?: number,
  marginRight?: number,
  className?: string,
}

const MandatoryLabel: React.FC<MandatoryLabelI> = ({ marginLeft = 4, marginRight = 4, className, ...props }) => (
  <span className={className || 'error'} style={{ marginLeft, marginRight }} {...props}>*</span>
);

export default MandatoryLabel;
